import Axios from './axios'

// 封装User类型的接口方法
export class RecommendService {
  // eslint-disable-next-line require-await
  static async getRecommend(params: any) {
    return Axios('/common/recommend_list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // eslint-disable-next-line require-await
  static async getSubjectCategory(params: any) {
    return Axios('/subject/category-list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // eslint-disable-next-line require-await
  static async getSubjectDetail(id: any) {
    return Axios('/subject/ppt-item_list-' + id + '/', {
      method: 'post',
      responseType: 'json',
    })
  }

}

